import { configureStore } from "@reduxjs/toolkit";
import BurgerSlice from "./BurgerSlice/BurgerSlice";
import ModalSlice from "./ModalSlice/ModalSlice";

const store = configureStore({
  reducer: {
    modal: ModalSlice,
    burger: BurgerSlice,
  },
});

export default store;
